/* ————————————————————————————————————————————————————————————————————————————————
pango-cze-calendar.js
Este fichero se llama en theme.liquid

se inicializa el calendario: 
    - Al clicar botón "pagar"
se reinicializa el calendario y se "limpian" los eventos cada vez que pulsamos botón "pagar"
———————————————————————————————————————————————————————————————————————————————— */
//————————————————————————————————————————————————————————————————————————————————
//                                 CALENDARIO CLASS
//————————————————————————————————————————————————————————————————————————————————
class CzeCalendar {
    //———————————————————————————————— CONSTRUCTOR ———————————————————————
    constructor() {
        this.element = document.getElementById('czeCalendar');

        if (!this.element) {
            console.error('Element with id "czeCalendar" not found');
            return;
        }

        //—————————   variables —————————
        this.dataForCalendar = {
            cartHasPlus24hProduct: undefined,
            cartHasPrep72h: undefined,
            date: undefined,
            recogidaEnTienda:undefined,
            todaysDate: undefined,
            dentroM50: undefined,
            diasCierre: diasCierre,
            diasSinReparto: diasSinReparto,
            horaCorte: undefined,
        };
        this.horarioHoraDeCorte = 14;

        // DÍAS NO DISPONIBLES FUERA M50: primer día de entrega según el día del pedido, antes / después de las 14:00
        // (cuadro confirmado por Andrea el 31/10/2026)
        this.reglasFueraM50 = {
            1: { before: [3], after: [4] },   // Lunes → miércoles / jueves
            2: { before: [4], after: [5] },   // Martes → jueves / viernes
            3: { before: [5], after: [2] },   // Miércoles → viernes / martes
            4: { before: [2], after: [2] },   // Jueves → martes / martes
            5: { before: [2], after: [2] },   // Viernes → martes / martes
            6: { before: [2], after: [2] },   // Sábado → martes / martes
            0: { before: [2], after: [2] },   // Domingo → martes / martes
        };
        // RECOGIDA EN TIENDA - sin producto +24h
        this.reglasRecogidaSinPlus24 = {
            1: { before: 2, after: 3 },   // Lunes → martes / miércoles
            2: { before: 3, after: 4 },   // Martes → miércoles / jueves
            3: { before: 4, after: 5 },   // Miércoles → jueves / viernes
            4: { before: 5, after: 6 },   // Jueves → viernes / sábado
            5: { before: 6, after: 1 },   // Viernes → sábado / lunes
            6: { before: 1, after: 1 },   // Sábado → lunes / lunes
            0: { before: 1, after: 2 },   // Domingo → lunes / martes
        };
        // RECOGIDA EN TIENDA - con producto +24h
        this.reglasRecogidaConPlus24 = {
            1: { before: 3, after: 4 },   // Lunes → miércoles / jueves
            2: { before: 4, after: 5 },   // Martes → jueves / viernes
            3: { before: 5, after: 6 },   // Miércoles → viernes / sábado
            4: { before: 6, after: 1 },   // Jueves → sábado / lunes
            5: { before: 1, after: 2 },   // Viernes → lunes / martes
            6: { before: 2, after: 2 },   // Sábado → martes / martes
            0: { before: 2, after: 3 },   // Domingo → martes / miércoles
        };

        // RECOGIDA EN TIENDA - con producto de 72 h (Andrea, 03/11/2026: panettones). Un día de apertura más que con +24h
        this.reglasRecogidaCon72h = {
            1: { before: 4, after: 5 },   // Lunes → jueves / viernes
            2: { before: 5, after: 6 },   // Martes → viernes / sábado
            3: { before: 6, after: 1 },   // Miércoles → sábado / lunes
            4: { before: 1, after: 2 },   // Jueves → lunes / martes
            5: { before: 2, after: 3 },   // Viernes → martes / miércoles
            6: { before: 3, after: 3 },   // Sábado → miércoles / miércoles
            0: { before: 3, after: 4 },   // Domingo → miércoles / jueves
        };

        // VARIABLES BASE DE CALENDARIO
        this.specialProductLeadDays = 1;
        this.prep72hLeadDays = 2;

        this.insideM50BeforeHoraCorte = 1;
        this.insideM50AfterHoraCorte = 2;

        this.outsideM50BeforeHoraCorte = 0;
        this.outsideM50AfterHoraCorte = 1;

        //ELEMENTOS DEL CALENDARIO
        this.listenersBound = false;

        this.monthArea = this.element.querySelector('[data-calendar-area="month"]');
        this.nextBtn = this.element.querySelector('[data-calendar-toggle="next"]');
        this.prevBtn = this.element.querySelector('[data-calendar-toggle="previous"]');
        this.monthNameArea = this.element.querySelector('[data-calendar-label="month"]');
        this.pickedLabel = this.element.querySelector('[data-calendar-label="picked"]');
        //this.hiddenInput = this.element.querySelector('#calendar-date-input');

        this.init();
    } // end constructor

    init() {
        this.doTheMagic();
        this.initTestingInputs();
    }
    //———————————————————————————————— METODOS  ———————————————————————
    //—————————   metodos principales —————————
    doTheMagic() {
        this.updateDataForCalendar();
        this.initAddDatesToCalendar();
    }
    refresh() {
        this.element = document.getElementById('czeCalendar');
        this.doTheMagic();
    }
    initTestingInputs() {
        this.testingInputActivate = document.querySelector("#testingInputActivate");
        this.testingForm = document.querySelector("#czeTestingForm");

        if (!this.testingForm) return;

        this.testingSubmitButton = this.testingForm.querySelector(
            '[data-action="aplicarCambiosCalendarioManual"]'
        );
        document.addEventListener("click", (e) => {
            if (!e.target.closest("#czeTestingFormBtn")) return;
            this.testingInputActivate = document.querySelector("#testingInputActivate");
            this.testingForm = document.querySelector("#czeTestingForm");
            if (!this.testingInputActivate?.checked) {
                return;
            }
            const values = this.getTestingFormValues();
            this.refresh();
        });

        // refresh cada vez que se activa/desactiva
        this.testingInputActivate?.addEventListener("change", () => {
            this.refresh();
        });
    }
    getTestingFormValues() {
        const formData = new FormData(this.testingForm);

        return {
            testingDate: formData.get("testingDate"),
            cutoffHour: formData.get("cutoffHour"),
        };
    }
    isBeforeCutoff() {
        const now = new Date();
        const spainTime = new Date(
            now.toLocaleString("en-US", {
                timeZone: "Europe/Madrid"
            })
        );
        
        const hour = spainTime.getHours();
        return hour < this.horarioHoraDeCorte;
    }
    getMadridDate() {
        const now = new Date();

        const madridTime = new Intl.DateTimeFormat("en-US", {
            timeZone: "Europe/Madrid",
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour12: false
        }).formatToParts(now);

        const get = (type) =>
            madridTime.find(p => p.type === type).value;

        return new Date(
            get("year"),
            get("month") - 1,
            get("day"),
        );
    }
    updateDataForCalendar() {
        const czeSessionDataRaw = localStorage.getItem('czeSessionData');
        
        if (!czeSessionDataRaw) {
            throw new Error('Missing czeSessionData');
        }

        const czeSessionData = JSON.parse(czeSessionDataRaw);

        this.dataForCalendar.recogidaEnTienda = czeSessionData.recogidaEnTienda;
        this.dataForCalendar.dentroM50 = !czeSessionData.entregaFueraM50;
        this.dataForCalendar.cartHasPlus24hProduct = czeSessionData.cartHasPlus24hProduct || false;  
        this.dataForCalendar.cartHasPrep72h = czeSessionData.cartHasPrep72h || false;

        if (this.testingInputActivate?.checked) {
            const testingValues = this.getTestingFormValues();

            this.dataForCalendar.date = testingValues.testingDate ?
                new Date(testingValues.testingDate) :
                this.getMadridDate();

            this.dataForCalendar.todaysDate = testingValues.testingDate ?
                new Date(testingValues.testingDate) :
                this.getMadridDate();

            this.dataForCalendar.horaCorte = testingValues.cutoffHour === "true";
        } else {
            this.dataForCalendar.date = this.getMadridDate();
            this.dataForCalendar.todaysDate = this.getMadridDate();
            this.dataForCalendar.horaCorte = this.isBeforeCutoff();
        }
    }
    //MÉTODOS PARA GENERAR MESES Y DÍAS
    initAddDatesToCalendar() {
        //MANEJO DE ERRORES 
         const requiredFields = [
            'date',
            'todaysDate',
            'recogidaEnTienda',
            'horaCorte',
            'dentroM50',
            'diasCierre',
            'cartHasPlus24hProduct'
         ];
         const missingFields = requiredFields.filter(
             key => this.dataForCalendar[key] === undefined || this.dataForCalendar[key] === null
         );
         if (missingFields.length > 0) {
             throw new Error(
                 `Calendar init error: Missing required this.dataForCalendar fields: ${missingFields.join(', ')}`
             );
         }

        //VALIDACIÓN DE BOOLEANOS
        const booleanFields = ['horaCorte', 'dentroM50', 'cartHasPlus24hProduct'];
        const invalidBooleans = booleanFields.filter(
             key => typeof this.dataForCalendar[key] !== 'boolean'
         );
         if (invalidBooleans.length > 0) {
             throw new Error(
                 `Calendar init error: These fields must be boolean (true/false): ${invalidBooleans.join(', ')}`
             );
         } 
        
        //EMPEZAMOS A PINTAR LOS MESES
        try {
            this.renderMonthDays();
            this.createNavigationMonthListeners();
        } catch (err) {
            console.error("CzeCalendar render failed:", err);
        }
    }
    createNavigationMonthListeners () {
        if (this.listenersBound) return;
        this.listenersBound = true;
        
        this.nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const d = this.dataForCalendar.date;
            d.setDate(1);
            d.setMonth(d.getMonth() + 1);

            this.renderMonthDays();
        });
        this.prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const d = this.dataForCalendar.date;
            d.setDate(1);
            d.setMonth(d.getMonth() - 1);

            this.renderMonthDays();
        });
    }
    // CREACIÓN DE MESES
    renderMonthDays() {
        //AÑADIMOS NOMBRE DEL MES Y AÑO DENTRO DE this.monthArea
        if (!this.dataForCalendar.date) return;
        let month = this.dataForCalendar.date.getMonth();
        let monthName = this.dataForCalendar.date.toLocaleString('es-ES', { month: 'long'});
        let year = this.dataForCalendar.date.getFullYear();
        
        this.monthArea.innerHTML = "";
        this.monthNameArea.innerHTML = `${monthName} ${year}`;

        //VEMOS A QUE NUMERO CORRESPONDE EL PRIMER DIA DEL MES PARA CALCULAR OFFSET
        let firstDay = new Date(year, month, 1).getDay();
        let offset = firstDay === 0 ? 6 : firstDay - 1;

        for (let i = 0; i < offset; i++) {
            const emptyDiv = document.createElement('div');
            emptyDiv.className = 'cal__date';
            this.monthArea.appendChild(emptyDiv);
        }

        //POR CADA DIA DEL MES LLAMAMOS A this.createday() PARA GENERAR LOS DÍAS
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        
        for (let i = 1; i < daysInMonth + 1; i++) {
            const cellDate = new Date(year, month, i);
            this.createDay(i, cellDate);
        } 
    }
    // HELPER FUNCTIONS DE CREACIÓN DE DÍAS
    checkVacationDate(dateWereChecking, dias = this.dataForCalendar.diasCierre){
        function normalizeDate(date) {
            const d = new Date(date);
            return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
        }

        let diasNoDisponibles = dias.map(normalizeDate);

        const normalized = normalizeDate(dateWereChecking);
        return diasNoDisponibles.includes(normalized);
    
    }
    getAllowedWeekdays(today, horaCorte){
        const day = new Date(today).getDay();
        const tipo = horaCorte ? "before" : "after";

        return this.reglasFueraM50[day][tipo];
    }  
    getNextWeekday(baseDate, targetDay){
        const date = new Date(baseDate);
        const currentDay = date.getDay();

        let diff = targetDay - currentDay;
        if (diff <= 0) diff += 7;

        date.setDate(date.getDate() + diff);
        return new Date(date).setHours(0,0,0,0);
    }
    getMadridMidnightTimestamp(date) {
        const parts = new Intl.DateTimeFormat("en-US", {
            timeZone: "Europe/Madrid",
            year: "numeric",
            month: "numeric",
            day: "numeric",
        }).formatToParts(date);

        const get = (type) => parts.find(p => p.type === type).value;

        return Date.UTC(
            get("year"),
            get("month") - 1,
            get("day")
        );
    }
    getLeadDays(){
        let leadDays;
        // 72 h: en domicilio y en envío nacional, los mismos días de antelación
        if (this.dataForCalendar.cartHasPrep72h) {
            leadDays = this.dataForCalendar.horaCorte ? this.insideM50BeforeHoraCorte : this.insideM50AfterHoraCorte;
            return leadDays + this.prep72hLeadDays;
        }
        if (this.dataForCalendar.dentroM50){
            leadDays = this.dataForCalendar.horaCorte ? this.insideM50BeforeHoraCorte : this.insideM50AfterHoraCorte;
            if (this.dataForCalendar.cartHasPlus24hProduct) {
                leadDays += this.specialProductLeadDays;
            }
        } else {
            leadDays = this.dataForCalendar.horaCorte ? this.outsideM50BeforeHoraCorte : this.outsideM50AfterHoraCorte;
        }
        return leadDays;
    }
    buildDayElement(num){
        const dayElBase = document.createElement('div');
        dayElBase.className = 'cal__date';
        dayElBase.innerHTML = `<span>${num}</span>`;

        return dayElBase;
    }
    getLastBlockedDate(today) {
        const msInDay = 24 * 60 * 60 * 1000;
        return today + (this.getLeadDays() * msInDay);
    }
    getFirstValidStart() {
        if (this.dataForCalendar.dentroM50) return null;

        const allowedDays = this.getAllowedWeekdays(
            this.dataForCalendar.todaysDate,
            this.dataForCalendar.horaCorte
        );
        return Math.min(...allowedDays.map(day =>
            this.getNextWeekday(this.dataForCalendar.todaysDate, day)
        ));
    }
    getFirstValidPickupDate() {
        const today = this.dataForCalendar.todaysDate;
        const dayOfWeek = today.getDay();
        const tipo = this.dataForCalendar.horaCorte ? "before" : "after";

        const rules = this.dataForCalendar.cartHasPrep72h
            ? this.reglasRecogidaCon72h
            : this.dataForCalendar.cartHasPlus24hProduct
                ? this.reglasRecogidaConPlus24
                : this.reglasRecogidaSinPlus24;

        const targetDay = rules[dayOfWeek][tipo];

        return this.getNextWeekday(today, targetDay);
    }
    isDateDisabled(calendarDay, today, cellDate, dayOfWeek) {
        const isPastOrToday = calendarDay <= today;
        const isBlockedByAdmin = this.checkVacationDate(cellDate);  

        // ——— RECOGIDA EN TIENDA ———
        if (this.dataForCalendar.recogidaEnTienda) {
            const firstValidPickup = this.getFirstValidPickupDate();
            const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

            // Only weekends blocked if they fall before firstValidPickup,
            // weekdays always need to be >= firstValidPickup
            return (
                isPastOrToday     ||
                isBlockedByAdmin  ||
                calendarDay < firstValidPickup
            );
        }
         
        // ——— DELIVERY ——
        //case inside m50
        const lastBlockedDate = this.getLastBlockedDate(today);
         //case outside m50
        const firstValidStart = this.getFirstValidStart();
        const isMondayBlockedOutsideM50 = !this.dataForCalendar.dentroM50 && dayOfWeek === 1;
        const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
        const isPastOrLeadTime = calendarDay <  lastBlockedDate;
        // festivos sin reparto: no se entrega ni se envía, pero sí se recoge en tienda
        const isSinReparto = this.checkVacationDate(cellDate, this.dataForCalendar.diasSinReparto);
        // envío nacional: el día después de un festivo sin reparto tampoco llega (ese día no sale ningún envío)
        const diaAnterior = new Date(cellDate);
        diaAnterior.setDate(diaAnterior.getDate() - 1);
        const isDayAfterSinRepartoOutsideM50 = !this.dataForCalendar.dentroM50 && this.checkVacationDate(diaAnterior, this.dataForCalendar.diasSinReparto);


        let isRestrictedWeekday = false;
        if (!this.dataForCalendar.dentroM50 && firstValidStart && calendarDay < firstValidStart) {
            const allowedDays = this.getAllowedWeekdays(
                this.dataForCalendar.todaysDate,
                this.dataForCalendar.horaCorte
            );
            isRestrictedWeekday = !allowedDays.includes(dayOfWeek);
        }

        return (
            isMondayBlockedOutsideM50 ||
            calendarDay <= today        ||
            isWeekend                 ||
            isPastOrLeadTime          ||
            isRestrictedWeekday       ||
            isBlockedByAdmin          ||
            isSinReparto              ||
            isDayAfterSinRepartoOutsideM50
        );
    }
    handleDayClick(dayEl, cellDate) {

        document.querySelectorAll('.cal__date--selected').forEach(el => el.classList.remove('cal__date--selected'));
        dayEl.classList.add('cal__date--selected');

        const formattedDateText = cellDate.toLocaleDateString('es-ES', {
            timeZone: 'Europe/Madrid', 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric'
        });


        this.pickedLabel.innerHTML = formattedDateText;
        //this.hiddenInput.value = formattedDateText;
        const formattedDateNumber = new Date(cellDate).toLocaleDateString('es-ES', { 
            timeZone: 'Europe/Madrid' 
        });
        this.pickedLabel.dataset.selectedDeliveryDate = formattedDateNumber;
        const calendarCheckoutBtn = document.getElementById('calendarCheckoutBtn');
        calendarCheckoutBtn.disabled = false;
    }
    // CREACIÓN DE DÍAS
    createDay(num, cellDate) {
        const dayEl = this.buildDayElement(num);
        
        //what day is this cell in the calendar?
        const calendarDay = this.getMadridMidnightTimestamp(cellDate);
        //what day is it right now?
        const today = this.getMadridMidnightTimestamp(this.dataForCalendar.todaysDate);
        //what day of the week is this cell?
        const dayOfWeek = cellDate.getDay();

        if (calendarDay === today) dayEl.classList.add('cal__date--today');

        if (this.isDateDisabled(calendarDay, today, cellDate, dayOfWeek)) {
            dayEl.classList.add('cal__date--disabled');
        } else {
            dayEl.classList.add('cal__date--active');
            dayEl.addEventListener('click', () => this.handleDayClick(dayEl, cellDate));
        }

        //FINALMENTE AÑADIMOS EL ELEMENTO DENTRO DE monthArea
        this.monthArea.appendChild(dayEl);
    } 
    cleanCalendar() {
        if (this.nextBtn) {
            this.nextBtn.replaceWith(this.nextBtn.cloneNode(true));
        }

        if (this.prevBtn) {
            this.prevBtn.replaceWith(this.prevBtn.cloneNode(true));
        }
        if (this.testingSubmitButton) {
            this.testingSubmitButton.replaceWith(this.testingSubmitButton.cloneNode(true));
        }

        if (this.testingInputActivate) {
            this.testingInputActivate.replaceWith(this.testingInputActivate.cloneNode(true));
        }

        if (this.monthArea) {
            this.monthArea.innerHTML = '';
        }

        this.listenersBound = false;
    }
}

//———————————————————————————————— START ———————————————————————
// START ON CLICK "PAGAR" BUTTON
let czeCalendar = null;

function initCzeCalendar() {
    //LIMPIAMOS INSTANCIA ANTERIOR
    if (czeCalendar) {
        czeCalendar.cleanCalendar();
        czeCalendar = null;
    }

    //CREAMOS NUEVA INSTANCIA 
    const el = document.getElementById('czeCalendar');
    if (!el) {
        console.warn('Calendar element not found at init time');
        return;
    }

    czeCalendar = new CzeCalendar();
}
//————————————————————————————————————————————————————————————————————————————————
//                                 xxx
//————————————————————————————————————————————————————————————————————————————————